module.exports = __webpack_public_path__ + "static/media/trimap-logo.505dbf6c.jpg";